/**
 * Created by maty on 13/02/2017.
 */
import {SystemPreferences} from "./entities/system-preferences";
import {Injectable, Output, EventEmitter} from "@angular/core";
import {Http, Headers} from "@angular/http";
import {Auth} from "./app.auth";
import {GroupType} from "./enums/group-type.enum";
import {environment} from "../environments/environment";
/**
 * Created by maty on 13/02/2017.
 */

@Injectable()
export class AppConfig {
    public static API_ROOT = environment.domen;
    public static VERSION = "1.0";

    private _systemPreference: SystemPreferences;

    constructor(private _http: Http, private _auth: Auth) {}

    load() {
        return new Promise((resolve, reject) => {
            this._http
                .get(AppConfig.API_ROOT + "/systemPreferences")
                .map(response => response.json())
                .subscribe(response => {
                    this._systemPreference = response.system_preferences;

                    if ( this._auth.authToken ) {
                        let headers = new Headers();
                        headers.append("X-Authorization", this._auth.authToken);
                        headers.append("X-ClientVersion", "cms-" + AppConfig.VERSION);
                        headers.append("X-Language", "en-US");

                        this._http
                            .get(AppConfig.API_ROOT + "/user/getDetails", { headers: headers } )
                            .map(response => response.json())
                            .subscribe(response => {
                                console.log(response)
                                if(response.error_code != 0) {
                                    this._auth.authToken = "";
                                    this._auth.user = null;
                                    location.reload();
                                }else{
                                    if (response.user.id && response.user.permissions.group_id == GroupType.FullManager) {
                                        this._auth.user = response.user;
                                    }
                                    else {
                                        this._auth.user = null;
                                    }

                                    resolve(true);
                                }
                            })
                    }
                    else {
                        resolve(true);
                    }
                });
        });
    }

    getPreferences() {
        return this._systemPreference;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts